<template>
  <b-row>
    <b-col>
      <vue-form :state="formstate" @submit.prevent="handleSubmit">
        <b-row>
          <b-col>
            <label for="title">{{$t('views.promotions.form.title')}}: </label>
            <input id="title" type="text" class="form-control" v-model="item.title">
            <label for="description">{{$t('views.promotions.form.description')}}: </label>
            <input id="description" type="text" class="form-control" v-model="item.description">
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <label>{{$t('views.promotions.form.state')}}: </label>
            <div>
              <b-form-radio-group buttons button-variant="outline-primary" id="requirePromotion" v-model="item.state">
                <b-form-radio button-variant="outline-primary" :value="1">{{$t('views.promotions.form.active')}}</b-form-radio>
                <b-form-radio button-variant="outline-primary" :value="0">{{$t('views.promotions.form.inactive')}}</b-form-radio>
              </b-form-radio-group>
            </div>
          </b-col>
          <b-col cols="6">
            <label>{{$t('views.promotions.form.type')}}: </label>
            <div>
              <b-form-radio-group buttons button-variant="outline-primary" id="requirePromotion" v-model="item.type">
                <b-form-radio button-variant="outline-primary" :value="0">{{$t('views.promotions.form.amountvalue')}}</b-form-radio>
                <b-form-radio button-variant="outline-primary" :value="1">{{$t('views.promotions.form.percentvalue')}}</b-form-radio>
              </b-form-radio-group>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="item.type == 0 || item.type == 1">
          <b-col cols="6">
            <label>{{$t('views.promotions.form.joinPromotions')}}: </label>
            <div>
              <b-form-radio-group buttons button-variant="outline-primary" id="canjoin" v-model="item.canjoin">
                <b-form-radio button-variant="outline-primary" :value="1">{{$t('views.promotions.form.canjoinYes')}}</b-form-radio>
                <b-form-radio button-variant="outline-primary" :value="0">{{$t('views.promotions.form.canjoinNo')}}</b-form-radio>
              </b-form-radio-group>
            </div>
          </b-col>
          <b-col cols="6">
            <label>{{$t("global.value")}}: <b>{{ item.value }}</b></label>
            <input id="value" type="number" :placeholder="$t('global.value')" class="form-control" v-model="item.value">
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <label>{{$t("views.exsbitems.form.rangeFrom")}}: <b>{{ item.rangeFrom }}</b></label>
            <input id="rangeFrom" type="number" :placeholder="$t('views.exsbitems.form.rangeFrom')" class="form-control" v-model="item.rangeFrom">
          </b-col>
          <b-col cols="6">
            <label>{{$t("views.exsbitems.form.rangeTo")}}: <b>{{ item.rangeTo }}</b></label>
            <input id="rangeTo" type="number" :placeholder="$t('views.exsbitems.form.rangeTo')" class="form-control" v-model="item.rangeTo">
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <label>{{$t('views.promotions.form.addOnlyIfPaidInvoices')}}: </label>
            <div>
              <b-form-radio-group buttons button-variant="outline-primary" id="canjoin" v-model="item.addOnlyIfPaidInvoices">
                <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
                <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
              </b-form-radio-group>
            </div>
          </b-col>
          <b-col cols="6">
            <label>{{$t('views.promotions.form.itemAsPromotion')}}: </label>
            <model-select id="item_input" :options="itemOptionsSelect" v-model="item.itemAsPromotion"></model-select>
          </b-col>
        </b-row>
<!--        <b-row class="mt-2">-->
<!--          <b-col>-->
<!--            <b-button class="btn-sm"  v-b-toggle.promotion-advanced-params variant="primary">-->
<!--              <span class="when-closed">{{$t('views.promotions.form.advancedParams')}}</span>-->
<!--            </b-button>-->
<!--          </b-col>-->
<!--        </b-row>-->
<!--        <b-row>-->
<!--          <b-col>-->
<!--            <b-collapse id="promotion-advanced-params" class="mt-2">-->
<!--              <b-row>-->
<!--                <b-col cols="6">-->
<!--                  <label for="dateFrom">{{$t("views.promotions.form.dateFrom")}}:</label>-->
<!--                  <fg-input :error="violations.dateFrom">-->
<!--                    <el-date-picker-->
<!--                      v-model="item.dateFrom"-->
<!--                      type="date"-->
<!--                      default-time="00:00:00">-->
<!--                    </el-date-picker>-->
<!--                  </fg-input>-->
<!--                </b-col>-->
<!--                <b-col cols="6">-->
<!--                  <label for="dateTo">{{$t("views.promotions.form.dateTo")}}:</label>-->
<!--                  <fg-input :error="violations.dateTo">-->
<!--                    <el-date-picker-->
<!--                      v-model="item.dateTo"-->
<!--                      type="date"-->
<!--                      default-time="00:00:00">-->
<!--                    </el-date-picker>-->
<!--                  </fg-input>-->
<!--                </b-col>-->
<!--              </b-row>-->
<!--              <b-row>-->
<!--                <b-col cols="6">-->
<!--                  <label>{{$t('views.promotions.form.importance')}}: </label>-->
<!--                  <model-select :placeholder="$t('views.promotions.form.importance')" :options="importanceOptions" v-model="item.importance"></model-select>-->
<!--                </b-col>-->
<!--                <b-col cols="6" v-if="item.type == 1">-->
<!--                  <label>{{$t('views.promotions.form.limitStatus')}}: </label>-->
<!--                  <div>-->
<!--                    <b-form-radio-group buttons button-variant="outline-primary" id="canjoin" v-model="item.limitStatus">-->
<!--                      <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>-->
<!--                      <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>-->
<!--                    </b-form-radio-group>-->
<!--                  </div>-->
<!--                </b-col>-->
<!--                <b-col cols="6" v-if="item.type == 1 && item.limitStatus == 1">-->
<!--                  <label for="limitValue">{{$t("views.promotions.form.limitValue")}}: <b>{{ item.limitValue }}</b></label>-->
<!--                  <input id="limitValue" type="number" :placeholder="$t('views.promotions.form.limitValue')" class="form-control" v-model="item.limitValue">-->
<!--                </b-col>-->
<!--              </b-row>-->
<!--            </b-collapse>-->
<!--          </b-col>-->
<!--        </b-row>-->
        <b-row>
          <b-col>
            <div class="mt-2">
              <button v-if="item['@id']" type="button" class="btn btn-primary" @click="handleSubmit">{{$t('buttons.update')}}</button>
              <button v-else type="button" class="btn btn-primary" @click="handleSubmit">{{$t('buttons.create')}}</button>
            </div>
          </b-col>
        </b-row>
      </vue-form>
    </b-col>
  </b-row>
</template>

<script>
import VueForm from 'vue-form'
import * as options from '@/components/Dashboard/Views/AgreementsBundle/agreements/vueFormOptions'
import { mapGetters, mapActions } from 'vuex'
import { ModelSelect } from 'vue-search-select'

export default {
  name: 'Form',
  components: {
    ModelSelect
  },
  mixins: [new VueForm(options)],
  created () {
    this.fetchItemsOptions()
  },
  data () {
    return {
      formstate: {},
      violations: {},
      specialModelTypeOptions: [
        { value: 0, text: this.$t('views.promotions.form.select') },
        { value: 1, text: this.$t('views.promotions.form.specialModelTypeCancelLastQuantity') }
      ],
      importanceOptions: [
        { value: 0, text: this.$t('views.promotions.form.importanceSelect.null') },
        { value: 1, text: this.$t('views.promotions.form.importanceSelect.one') },
        { value: 2, text: this.$t('views.promotions.form.importanceSelect.two') },
        { value: 3, text: this.$t('views.promotions.form.importanceSelect.three') },
        { value: 4, text: this.$t('views.promotions.form.importanceSelect.four') },
        { value: 5, text: this.$t('views.promotions.form.importanceSelect.five') },
        { value: 6, text: this.$t('views.promotions.form.importanceSelect.six') },
        { value: 7, text: this.$t('views.promotions.form.importanceSelect.seven') },
        { value: 8, text: this.$t('views.promotions.form.importanceSelect.eight') },
        { value: 9, text: this.$t('views.promotions.form.importanceSelect.nine') }
      ]
    }
  },
  computed: {
    ...mapGetters({
      item: 'promotions/getPromotion',
      itemOptions: 'exsbitem/list/itemOptions'
    }),
    itemOptionsSelect () {
      return [{ value: null, text: this.$t('null') }, ...this.itemOptions]
    }
  },
  methods: {
    handleSubmit () {
      this.item.value = this.item.value.toString()
      if (this.item.limitValue) {
        this.item.limitValue = this.item.limitValue.toString()
      }
      if (this.item.firstValue) {
        this.item.firstValue = this.item.firstValue.toString()
      }
      this.item.cancelLastQuantity = parseInt(this.item.cancelLastQuantity)
      if (typeof this.item.rangeFrom === 'number') this.item.rangeFrom = this.item.rangeFrom.toString()
      if (typeof this.item.rangeTo === 'number') this.item.rangeTo = this.item.rangeTo.toString()
      if (this.item['@id']) {
        this.updateItem(this.item['@id'])
      } else {
        this.createItem()
      }
    },
    ...mapActions({
      createItem: 'promotions/create',
      updateItem: 'promotions/update',
      fetchItemsOptions: 'exsbitem/list/getItems'
    })
  }
}
</script>

<style scoped>

</style>
